import { useEffect, useMemo, useState } from 'react';
import { cn } from '@/utils/cn';

interface MassCountdownProps {
  startsAt: string;
  compact?: boolean;
  state?: 'scheduled' | 'started' | 'finished';
}

function getRemainingParts(startsAt: string) {
  const difference = new Date(startsAt).getTime() - Date.now();

  if (difference <= 0) {
    return null;
  }

  const totalSeconds = Math.floor(difference / 1000);
  const days = Math.floor(totalSeconds / 86_400);
  const hours = Math.floor((totalSeconds % 86_400) / 3_600);
  const minutes = Math.floor((totalSeconds % 3_600) / 60);

  return { days, hours, minutes };
}

export function MassCountdown({ startsAt, compact = false, state = 'scheduled' }: MassCountdownProps): JSX.Element {
  const [nowKey, setNowKey] = useState(() => Date.now());

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setNowKey(Date.now());
    }, 30_000);

    return () => window.clearInterval(intervalId);
  }, []);

  const remaining = useMemo(() => {
    void nowKey;
    return getRemainingParts(startsAt);
  }, [nowKey, startsAt]);

  if (!remaining || state === 'started' || state === 'finished') {
    return (
      <div
        className={cn(
          'mass-countdown',
          compact && 'mass-countdown--compact',
          state === 'finished' ? 'mass-countdown--finished' : 'mass-countdown--started',
        )}
      >
        <span className="mass-countdown__eyebrow">Mass Status</span>
        <strong>{state === 'finished' ? 'Finished' : 'In Progress'}</strong>
      </div>
    );
  }

  const primaryValue =
    remaining.days > 0 ? `${remaining.days}d ${remaining.hours}h` : `${remaining.hours}h ${remaining.minutes}m`;

  return (
    <div className={cn('mass-countdown', compact && 'mass-countdown--compact')}>
      <span className="mass-countdown__eyebrow">Countdown</span>
      <strong>{primaryValue}</strong>
      {!compact ? <span>{remaining.days > 0 ? 'until mass start' : 'until start'}</span> : null}
    </div>
  );
}
